import type { Link } from "~/components/header/types"
import Icon, { type AvailableIcons } from "~/components/ui/Icon"

interface Props {
    links: Link[]
}

export default function Links({ links }: Props) {
    if (!links?.length) return null

    return (
        <>
            {links.map(({ label, url, icon }, i) => (
                <li key={url ?? i}>
                    <a
                        className='flex items-center gap-2 max-lg:w-full max-lg:h-16 max-lg:px-2 max-lg:text-base max-lg:text-white max-lg:transition-colors max-lg:bg-black max-lg:active:bg-zinc-700 lg:justify-center'
                        href={url}
                    >
                        <Icon id={icon as AvailableIcons} size={20} />
                        <span>{label}</span>
                    </a>
                </li>
            ))}
        </>
    )
}
